import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { rowspan: "2" }
const _hoisted_3 = { rowspan: "2" }
const _hoisted_4 = { rowspan: "2" }
const _hoisted_5 = { rowspan: "2" }
const _hoisted_6 = { rowspan: "2" }
const _hoisted_7 = { rowspan: "2" }
const _hoisted_8 = { rowspan: "2" }
const _hoisted_9 = { colspan: "8" }
const _hoisted_10 = { rowspan: "2" }
const _hoisted_11 = { rowspan: "2" }
const _hoisted_12 = { colspan: "3" }
const _hoisted_13 = { rowspan: "2" }
const _hoisted_14 = { rowspan: "2" }
const _hoisted_15 = { class: "table-header" }

import i18n from '@/lang/i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderRow',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", _hoisted_1, [
      _createElementVNode("td", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.date')), 1),
      _createElementVNode("td", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.dayOfWeek')), 1),
      _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.startWork')), 1),
      _createElementVNode("td", _hoisted_5, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.endWork')), 1),
      _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.drivingTotalTime')), 1),
      _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.betweenEndAndStart')), 1),
      _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.mileage')), 1),
      _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.restraintTime')), 1),
      _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.workTime')), 1),
      _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.duplicationTime')), 1),
      _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.restPeriod')), 1),
      _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.overTime')), 1),
      _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.lateNightWorkingHours')), 1)
    ]),
    _createElementVNode("tr", _hoisted_15, [
      _createElementVNode("td", null, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.driving')), 1),
      _createElementVNode("td", null, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.break')), 1),
      _createElementVNode("td", null, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.loading')), 1),
      _createElementVNode("td", null, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.unloading')), 1),
      _createElementVNode("td", null, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.shipping')), 1),
      _createElementVNode("td", null, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.wait')), 1),
      _createElementVNode("td", null, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.others')), 1),
      _createElementVNode("td", null, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.sum')), 1),
      _createElementVNode("td", null, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.start')), 1),
      _createElementVNode("td", null, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.end')), 1),
      _createElementVNode("td", null, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.total')), 1)
    ])
  ], 64))
}
}

})